import { type FC, memo, useMemo, useState } from 'react';

import { translations } from './SelectLanguage';
import { productsLV } from '../translations/productsLV';
import { productsRU } from '../translations/productsRU';
import type { Language, ResultWithCorrectValue } from '../types';

import './ResultTable.css';
import { SaveResultsPopUp } from './SaveResultsPopUp';

interface ResultTableProps {
    results: ResultWithCorrectValue[];
    onPlayAgainClick: () => void;
    language: Language;
}

export const ResultTable: FC<ResultTableProps> = memo(({ results, onPlayAgainClick, language }) => {
    const [saveResultsPopupVisible, setSaveResultsPopupVisible] = useState(false);

    const renderSaveResultsPopup = useMemo(() => {
        if (saveResultsPopupVisible) {
            return (
                <>
                    <div className="quitGamePopupBackgroundBlur"></div>
                    <SaveResultsPopUp
                        results={results}
                        onQuitClick={() => setSaveResultsPopupVisible(false)}
                    />
                </>
            )
        }
    },[saveResultsPopupVisible, results]);

    const translatedProductNames = useMemo(() => {
        if (language === "ru") {
            return productsRU;
        }
        return productsLV;
    },[language])

    return (
        <div className="resultTable">
            <div className="resultsTitle">{translations.yourResults}</div>
            <table className="table">
                <tbody>
                    <tr>
                        <td className="titleRowCell">{translations.product}</td>
                        <td className="titleRowCell">{translations.yourAnswer}</td>
                        <td className="titleRowCell">{translations.correctAnswer}</td>
                    </tr>
                    {results.map((result)=>{
                        const rowClassName = result.isCorrect ? "tableRow" : "tableRow incorrect";
                        return (
                            <tr key={result.product} className={rowClassName}>
                                <td>{translatedProductNames[result.product]}</td>
                                <td>{translations[result.color]}</td>
                                <td>{translations[result.correctAnswer]}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <button onClick={onPlayAgainClick} className="playAgainButton">{translations.playAgain}</button>
            <button onClick={() => setSaveResultsPopupVisible(true)} className="saveResultsButton">{translations.saveResults}</button>
            {renderSaveResultsPopup}
        </div>
    );
});
